import { getAuth, signOut } from "firebase/auth";
import { collection, getFirestore, query, where } from "firebase/firestore";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useAuthState } from "react-firebase-hooks/auth";
import { useCollection } from "react-firebase-hooks/firestore";
import { useNavigate, useParams } from "react-router-dom";
import { projectDocumentSchema } from "../../types/firestore";
import { useMemo } from "react";
import { getFirestoreZodConverter } from "../../modules/firestoreZodConverter";
import roleNames from "../../modules/roleNames";

const auth = getAuth();
const firestore = getFirestore();

export default function Header() {
	const navigate = useNavigate();

	const { projectId } = useParams();

	const [user, userLoading] = useAuthState(auth);

	const projectsQuery = useMemo(
		() =>
			user &&
			query(
				collection(firestore, "Projects"),
				where("Members." + user.uid, "!=", null),
			).withConverter(getFirestoreZodConverter(projectDocumentSchema)),
		[user],
	);

	const [projectsSnapshot] = useCollection(projectsQuery);

	return (
		<Navbar className="mb-3 sticky-top" variant="dark" bg="dark" expand="lg">
			<Container>
				<Navbar.Brand role="button" onClick={() => navigate("/")}>
					<img
						src="/img/logoDark.svg"
						height="45"
						className="d-inline-block align-top"
						alt="MasterGrill"
					/>
				</Navbar.Brand>
				<Navbar.Toggle aria-controls="basic-navbar-nav" />
				<Navbar.Collapse>
					<Nav className="me-auto">
						{user && projectsSnapshot && (
							<NavDropdown
								title={
									<span>
										<i className="bi bi-archive-fill" />{" "}
										{projectId
											? projectsSnapshot.docs.find((project) => project.id === projectId)?.data()
													.Name
											: "Projekte"}
									</span>
								}>
								{projectsSnapshot.docs.map((doc) => (
									<NavDropdown.Item key={doc.id} onClick={() => navigate("/projects/" + doc.id)}>
										<div>{doc.data().Name}</div>
										<small>{roleNames[doc.data().Members[user.uid]]}</small>
									</NavDropdown.Item>
								))}

								{projectsSnapshot.docs.length > 0 && <NavDropdown.Divider />}

								<NavDropdown.Item onClick={() => navigate("/")}>
									Projekte verwalten
								</NavDropdown.Item>
							</NavDropdown>
						)}
						{projectId && (
							<Nav.Link onClick={() => navigate(`/projects/${projectId}/documents`)}>
								<i className="bi bi-folder-fill" /> Dokumente
							</Nav.Link>
						)}
					</Nav>
				</Navbar.Collapse>
				<Navbar.Collapse className="justify-content-end">
					<Nav>
						{!userLoading && (
							<NavDropdown
								title={
									<span>
										<i className="bi bi-person-circle" /> {user?.email ?? "Nicht angemeldet"}
									</span>
								}>
								<NavDropdown.Item onClick={() => navigate("/account")}>
									{user ? <span>Konto verwalten</span> : <span>Anmelden</span>}
								</NavDropdown.Item>
								{user && (
									<NavDropdown.Item
										onClick={() => {
											signOut(auth);
										}}>
										Abmelden
									</NavDropdown.Item>
								)}
							</NavDropdown>
						)}
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	);
}
